import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { NewProjectPage } from "@/features/dashboard/new-project-page";

const searchSchema = z.object({
  installation_id: z.coerce.number().optional(),
  setup_action: z.string().optional(),
  error: z.string().optional(),
  cmdk: z.literal("1").optional(),
  modal: z
    .enum(["org_settings", "user_settings", "project_settings"])
    .optional(),
});

export const Route = createFileRoute("/_authenticated/$orgSlug/new-project")({
  component: NewProjectPage,
  validateSearch: searchSchema,
});
